import { useState } from 'react';
import AppLayout from '../components/AppLayout';
import InvoiceUploader from '../components/InvoiceUploader';
import InvoiceTable from '../components/InvoiceTable';

export default function Invoices() {
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleUploadComplete = () => {
    setRefreshTrigger((prev) => prev + 1);
  };

  return (
    <AppLayout>
      <div className="p-6 space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-white mb-2">Invoice Management</h1>
          <p className="text-slate-400">Upload and scan invoices for duplicate billing and overcharges</p>
        </div>

        <InvoiceUploader onUploadComplete={handleUploadComplete} />
        <InvoiceTable refreshTrigger={refreshTrigger} />
      </div>
    </AppLayout>
  );
}
